export type CategoryGroup = { key: string; label: string; slugs: string[] };

export const CATEGORY_GROUPS: CategoryGroup[] = [
  { key: "all", label: "Todos", slugs: [] },
  {
    key: "tech",
    label: "Tecnología",
    slugs: ["computacion", "celulares-y-telefonos", "electronica-audio-video", "camaras-y-accesorios", "consolas-y-videojuegos"]
  },
  {
    key: "home",
    label: "Hogar",
    slugs: ["hogar-muebles-jardin", "electrodomesticos-y-aires-ac", "herramientas", "construccion"]
  },
  {
    key: "vehicles",
    label: "Vehículos",
    slugs: ["autos-motos-y-otros", "accesorios-para-vehiculos"]
  },
  {
    key: "fashion",
    label: "Moda",
    slugs: ["ropa-y-accesorios", "joyas-y-relojes"]
  },
  {
    key: "sports",
    label: "Deportes",
    slugs: ["deportes-y-fitness"]
  },
  {
    key: "kids",
    label: "Bebés y Niños",
    slugs: ["bebes", "juegos-y-juguetes"]
  },
  {
    key: "beauty_health",
    label: "Belleza y Salud",
    slugs: ["belleza-y-cuidado-personal", "salud-equipamiento-medico"]
  },
  {
    key: "pets",
    label: "Mascotas",
    slugs: ["mascotas"]
  },
  {
    key: "culture",
    label: "Cultura y Entretenimiento",
    slugs: [
      "musica-peliculas-series",
      "libros-revistas-comics",
      "arte-libreria-merceria",
      "entradas-para-eventos",
      "antiguedades-y-colecciones",
      "instrumentos-musicales"
    ]
  },
  {
    key: "work_services",
    label: "Trabajo y Servicios",
    slugs: ["industrias-y-oficinas", "servicios", "inmuebles", "agro"]
  },
  {
    key: "other",
    label: "Otros",
    slugs: ["alimentos-y-bebidas", "souvenirs-cotillon-fiestas", "otras-categorias"]
  }
];
